<!--
日付選択カレンダー
@props
  dateSub : 文字で表示される日付の初期値
  defaultFocus : カレンダーのフォーカスの初期値。
-->

<template>
  <div>
    <v-col cols="12">
      <v-menu v-model="showDatePicker" z-index="0" :close-on-click="false" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
          <v-textarea
            color="#0ddbc7"
            v-model="localizedDate"
            v-bind="attrs"
            v-on="on"
            readonly
            outlined
            hide-details="auto"
            class="text-h5"
            rows="1"
            auto-grow
          ></v-textarea>
        </template>
        <v-date-picker
          locale="jp"
          v-model="date"
          elevation="12"
          :width="400"
          :day-format="pickupDate"
          :picker-date.sync="pickerDate"
          :active-picker.sync="activePicker"
        >
          <v-btn text color="primary" @click="date = null">削除</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="datePickerCancel">キャンセル</v-btn>
          <v-btn text color="primary" @click="datePickerApply">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
  </div>
</template>

<script>
import DateWrapper from "../../logic/common/date-wrapper";

export default {
  computed: {
    /**
     * 検索対象日を表示日に変換して返す
     */
    localizedDate() {
      return new DateWrapper(this.registrationDate).format.localizedDate;
    },
  },
  props: ["dateSub", "defaultFocus"],
  data() {
    this.workDate = ""; //初期値
    return {
      showDatePicker: false,
      date: this.defaultFocus,
      beforeFocus: this.defaultFocus,
      registrationDate: this.workDate,
      pickerDate: null,
      activePicker: null,
    };
  },
  watch: {
    dateSub(newDate) {
      if (newDate) {
        let now = new DateWrapper(newDate).format;
        this.date = now.systemDate;
        this.registrationDate = now.systemDate;
      } else {
        this.date = null;
        this.registrationDate = null;
      }
    },
  },
  methods: {
    /**
     * 選択日を更新する
     */
    updateRegistrationDate(newRegistrationDate) {
      if (this.registrationDate != newRegistrationDate) {
        this.registrationDate = newRegistrationDate;
        this.beforeFocus = newRegistrationDate;
        this.date = newRegistrationDate;
        this.$emit("on-update-registration-date", this.registrationDate);
      }
    },
    /**
     * カレンダーピッカーの選択をキャンセルして閉じる
     */
    datePickerCancel() {
      // カレンダーピッカーのカーソルを変更前に戻す
      this.date = this.beforeFocus;
      // カレンダーピッカーを開いた時の表示月を変更前に戻す
      this.pickerDate = this.beforeFocus;
      // カレンダーピッカーを閉じる
      this.showDatePicker = false;
    },
    /**
     * カレンダーピッカーの選択日を検索対象日に反映する
     */
    datePickerApply() {
      this.updateRegistrationDate(this.date);
      // // カレンダーピッカーを閉じる
      this.showDatePicker = false;
    },
    /**
     * 対象日から日を取得する
     */
    pickupDate(date_string) {
      return new DateWrapper(date_string).format.build((d) => `${d.date.d}`);
    },
    /**
     * カレンダー用日付を設定する
     */
    setDateForDatePicker() {
      this.workDate = this.dateSub;
    },
  },
};
</script>

<!--DatePickerのスタイルを継承して書き換え、2つ目で改行するようにする -->
<style>
.v-date-picker-table th {
  background-color: #ffffff !important;
}

.v-date-picker-table__events {
  max-width: 20px !important;
  left: 6px !important;
  top: 24px !important;
}

.v-date-picker-table--date div {
  float: left !important;
  margin-bottom: 1px !important;
  margin-left: 1px !important;
  margin-right: 0px !important;
  margin-top: 0px !important;
}

.no-background-color {
  background-color: transparent !important;
  border-color: transparent !important;
}
</style>
